// extracted by mini-css-extract-plugin
module.exports = {"uploadWrap":"index_uploadWrap-1ttAU"};